import { ID, WoosatTelecomResponse } from '../../../../../_metronic/helpers'

export type ResellerGroup = {
  id?: any, // Unique identifier for the reseller group
  name?: string, // Name of the reseller group
  discount_type?: 'percentage' | 'fixed', // Type of discount applied
  discount_value?: number, // Value of the discount
  can_create_sub_resellers?: boolean, // Permission for group members to add sub-resellers
  sub_reseller_limit?: number, // Limit on the number of sub-resellers
  can_sub_reseller_create_subs?: boolean, // Whether sub-resellers in this group can create their own sub-resellers
  status?: 'active' | 'inactive', // Status of the reseller group
  notes?: string, // Additional notes or description for the group
  created_at?: string, // Timestamp when the group was created
  updated_at?: string, // Timestamp when the group was last updated
}

export type ResellerGroupsQueryResponse = WoosatTelecomResponse<ResellerGroup[]>

export const initialResellerGroup: ResellerGroup = {
  id: '', // Default empty ID
  name: '', // Default group name
  discount_type: 'percentage', // Default discount type
  discount_value: 0, // Default discount value
  can_create_sub_resellers: false, // Default to not allowing sub-resellers
  sub_reseller_limit: 0, // Default sub-reseller limit
  can_sub_reseller_create_subs: false, // Default to not allowing sub-resellers to create subs
  status: 'active', // Default status
  notes: '', // Default notes
  created_at: '', // Default creation timestamp
  updated_at: '', // Default update timestamp
}
